export enum Direction {
  RTL = 'rtl',
  LTR = 'ltr',
  AUTO = 'auto',
}

export type LayoutDirection = 'rtl' | 'ltr' | 'auto';
